import React from 'react';

import LoadingFilledIcon from '@travel/design-system/assets/icons/LoadingFilledIcon';

import cx from '../../utils/classNames';

import styles from './loading-spinner.module.scss';

type Props = {
  /** Custom class to overwrite default styling if needed */
  className?: string;
  /** Controls the size of the loading spinner in pixels */
  size?: number;
  /** Controls the color of the loading spinner */
  color?: string;
};

export const LoadingSpinner = (props: Props) => {
  const { className, size = 24, color } = props;

  const classNames = cx(styles.loadingSpinner, className);

  return (
    <div className={classNames} data-testid="loading-spinner">
      <LoadingFilledIcon size={size} color={color} className={styles.icon} />
    </div>
  );
};

export default LoadingSpinner;
